module.exports = ".width-100 {\n  width: 100%;\n}\n\n.flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n\nmat-icon-button {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 10%;\n          flex: 1 10%;\n}\n\nmat-icon {\n  color: #888;\n}\n\n.loader {\n  color: #3f51b5 !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/onix/onix-selector/onix-selector.component.css
// module id = ./src/app/components/onix/onix-selector/onix-selector.component.css
// module chunks = main